import React, {FunctionComponent} from "react";
import styles from "./Footnotes.module.scss";
import classNames from "classnames";
import JSONContent from "./content";
import cn from "classnames";
import {scrollView} from "../../libs/scrollView";

const Footnotes: FunctionComponent<{ contentString: string }> = ({ contentString}) => {
    const content: any = JSONContent;

    const disclaimers = process.env.REACT_APP_LANG === 'spanish' ? content.spanish.disclaimers : content.english.disclaimers;

    const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';

    let counter = 0

    return (
        <section
            id="disclaimers"
            className={classNames([styles.Footnotes, 'no-parallax'])}
            data-tracking="section-legal"
            lang={dataLang}
        >
            <div className={styles.border}/>
            <ul>
                {
                    disclaimers.tiles[contentString].map((x: any, j: number) => {
                        counter++;
                        return <li key={`disclaimer_${j}`}  id={`fn-${counter}`} tabIndex={-1}>
                            <p>
                                <a
                                    tabIndex={0}
                                    href={`#body-sup-${counter}`}
                                    role={'link'}
                                    aria-label={process.env.REACT_APP_LANG === 'spanish' ? `Enlace que remite a la nota al pie ${counter} dentro del contenido` : `Links back to footnote ${counter} in body content.`}

                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        const target = document.getElementById(e.target.href.split('#')[1])
                                        scrollView(target, {behavior: "smooth", block: "center"}, () => setTimeout(() => {
                                            target?.focus()
                                        }, 500));
                                    }}
                                    className={cn(styles.footnote, `disclaimer-link`)}
                                >{`${counter}.`}
                                </a>
                                &nbsp;
                                {x}
                            </p>
                        </li>
                    })
                }
                {

                    disclaimers.mobileApp.map((x: any, i: number) => {
                        counter++;
                        return <li key={`disclaimer_${i}`} tabIndex={-1} id={`fn-${counter}`}>
                            <p>
                                <a
                                    tabIndex={0}
                                    href={`#body-sup-${counter}`}
                                    role={'link'}
                                    aria-label={process.env.REACT_APP_LANG === 'spanish' ? `Enlace que remite a la nota al pie ${counter} dentro del contenido` : `Links back to footnote ${counter} in body content.`}
                                    onKeyPress={
                                        (e: any) => {
                                            e.preventDefault();
                                            if (e.which === 13) { //onEnter
                                                const target = document.getElementById(e.target.href.split('#')[1])
                                                scrollView(target, {behavior: "smooth", block: "center"}, () => setTimeout(() => {
                                                    target?.focus()
                                                }, 500));
                                            }
                                        }}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        const target = document.getElementById(e.target.href.split('#')[1])
                                        scrollView(target, {behavior: "smooth", block: "center"}, () => setTimeout(() => {
                                            target?.focus()
                                        }, 500));
                                    }}
                                    className={cn(styles.footnote, `disclaimer-link`)}
                                >{`${counter}.`}</a>
                                &nbsp;
                                {x}
                            </p>
                        </li>
                    })
                }
                {
                    disclaimers.post.map((x: any, i: number) => {
                        counter++;
                        return <li key={`disclaimer_${i}`} tabIndex={-1} id={`fn-${counter}`}>
                            <p>
                                {x}
                            </p>
                        </li>
                    })
                }
                {
                    contentString === 'startsmart' &&
                    <li>
                        <p>{disclaimers.cabOnly}</p>
                    </li>
                }
            </ul>
        </section>
    );
};

export default Footnotes;
